/** FilterArea 필드 id — 그대로 폼 값 키가 된다. */
export const FIELD_NAMES = {
  shipperCode: 'shipperCode',
  clsDateRange: 'clsDateRange',
  orderNumbers: 'orderNumbers',
  styleNumber: 'styleNumber',
  goodsCode: 'goodsCode',
} as const

/**
 * 그리드 페이지 크기 — schema n-head-table/n-item-table pageSize 10000
 * (페이지네이션 없이 전체 로드, 페이지 크기 선택 UI 미제공. [MOMS 규칙] as-is 10,000 고정과 동일).
 */
export const PAGE_SIZE = 10000

/** 마감일자 파라미터 포맷(yyyyMMdd — BE CLS_DATE 물리 포맷 동일). */
export const CLS_DATE_PARAM_FORMAT = 'YYYYMMDD'

/** 마감일자 표시 포맷 — 디자인 데모 표기(26-08-04). */
export const CLS_DATE_DISPLAY_FORMAT = 'YY-MM-DD'

/**
 * 주문상태(WEB_STO STATUS) 코드 → 화면 라벨. (디자인 태그 4종 — 이동지시·이동중·이동완료·취소)
 *
 * BE 상수(moms-be `StockTransferErpSummary`)는 WAIT(초기)·PROGRESS(진행)·CONFIRMED(확정 완료) 세 개고,
 * 1.0 EST01_HEAD 필터에 CHECK 가 함께 쓰인다. 취소 코드는 BE·1.0 어디에도 상수로 없어(2026-08-06 실측)
 * 흔한 표기 세 가지를 함께 받아 둔다 — **매핑에 없는 값은 원문 그대로 노출**한다(거짓 라벨을 만들지 않는다).
 */
export const STATUS_LABELS: Record<string, string> = {
  WAIT: '이동지시',
  PROGRESS: '이동중',
  CHECK: '이동중',
  CONFIRMED: '이동완료',
  CANCEL: '취소',
  CANCELED: '취소',
  CANCELLED: '취소',
}

/** 상세사유 최소 길이 — schema dr-detail minLength(1.0 RemarkPop 검증과 동일). */
export const REASON_DETAIL_MIN_LENGTH = 5

export const MESSAGES = {
  shipperRequired: '화주명을 선택해 주세요.',
  clsDateRequired: '마감일자를 선택해 주세요.',
  searchFailed: '조회 중 오류가 발생했습니다.',
  excelNoRows: '다운로드할 데이터가 없습니다.',
  /** 상품코드 서치헬퍼 — goods-codes 는 무페이징 distinct 라 조건 없이 받지 않는다(index.tsx enabled). 재고현황과 같은 문구. */
  goodsHelperConditionRequired: '브랜드명 또는 상품명을 입력한 뒤 조회해 주세요.',
} as const
